<template>
  <div>
    <LoadingSpinner :loading="loading" :text="loadingSpinnerText" />
    <b-alert
      v-show="
        parvandehCode &&
        !loading &&
        (!checkingHasHozehSelect || !currentProvinceId)
      "
      show
      variant="danger"
      class="mb-2"
    >
      <b-row align-h="center" align-v="center">
        <b-col cols="12" md="12">
          <i class="fas fa-info-circle fa-lg mr-2" />
          <strong v-text="noHozehSelectMessage" />
        </b-col>
      </b-row>
    </b-alert>
    <b-alert
      v-show="!parvandehCode"
      show
      variant="danger"
      class="font-weight-bold"
    >
      <i class="fas fa-info-circle fa-lg mr-2" />
      <span v-text="noParvandehCodeMessage" />
    </b-alert>
    <TwoStepWrapper
      v-show="
        parvandehCode && !loading && checkingHasHozehSelect && currentProvinceId
      "
      :parentLoading="loading"
      :registered="registered"
      :validSendCode="validSendCode"
      :submitted="submitted"
      :confirmLoadingSpinnerText="$lang.updating_data"
      :confirmContentText="confirmContentText"
      @setData="setHozehghazayi"
      @updateAccept="updateAccept"
    >
      <template slot="header">
        <div class="d-flex align-items-center fs_16 border-bottom pb-2 mb-3">
          <i :class="`${this.titleIcon} fa-lg mr-2`" />
          <b v-text="this.titleText" />
        </div>
        <div class="lh_30 mb-3" v-html="headerAlertText" />
      </template>
      <template slot="body">
        <b-overlay :show="loading">
          <template #overlay>
            <div class="mb-3">
              <b-spinner small />
              <strong class="ml-2" v-text="$lang.getInfoLoadingText" />
            </div>
          </template>
          <b-row
            v-if="isDraggable"
            class="mx-0 border rounded p-3 mb-3 bg-light"
          >
            <b-col cols="12" md="12">
              <DraggableList
                :items="generateDraggableItems"
                :showLabel="false"
                :draggable="isEditable"
                @getItems="updateDraggableItems"
              >
                <template slot="body" slot-scope="{ item, index }">
                  <span v-text="`${item.caption} (اولویت ${index + 1})`" />
                </template>
              </DraggableList>
            </b-col>
          </b-row>
          <b-row
            v-if="!isDraggable && selectCount"
            class="mx-0 border rounded p-3 mb-3 bg-light"
          >
            <b-col cols="12" md="12">
              <b-row class="mb-3">
                <b-col
                  cols="1"
                  md="1"
                  class="text-center font-weight-bold px-0"
                  v-text="'اولویت'"
                />
                <b-col
                  cols="8"
                  md="8"
                  class="text-center font-weight-bold px-0"
                  v-text="tableTitleHoze"
                />
                <b-col
                  v-if="!registered"
                  cols="3"
                  md="3"
                  class="text-center font-weight-bold px-0"
                  v-html="'اقدام'"
                />
              </b-row>
            </b-col>
            <b-col
              cols="12"
              md="12"
              class="mb-3"
              v-for="(item, index) in items"
              :key="index"
            >
              <b-row
                v-if="registered"
                align-v="center"
                class="border rounded py-1 bg-white"
              >
                <b-col
                  cols="1"
                  md="1"
                  class="text-center px-0 pt-2"
                  v-text="index + 1"
                />
                <b-col
                  cols="8"
                  md="8"
                  class="text-center px-0"
                  v-text="item.item.caption"
                />
              </b-row>
              <b-row v-else>
                <b-col
                  cols="1"
                  md="1"
                  class="text-center px-0 pt-2"
                  v-text="index + 1"
                />
                <b-col cols="8" md="8" class="text-center px-0">
                  <selectFind
                    :options="hozehghazayiOptions"
                    v-model="item.item"
                    :loading="hozehghazayiLoading"
                    :placeholder="tableSearchPlaceHolderHoze"
                    label="caption"
                  />
                </b-col>
                <b-col
                  v-if="!registered"
                  cols="3"
                  md="3"
                  class="text-center px-0"
                >
                  <b-button
                    v-if="index"
                    size="sm"
                    variant="danger"
                    class="mt-1"
                    @click="removeItem(index)"
                  >
                    <i class="fas fa-times" />
                    <span
                      class="d-md-inline d-none ml-2"
                      v-text="'حذف این مورد'"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              v-if="showCancelAlert && hasData"
              cols="12"
              md="12"
              class="border rounded p-2 mb-3"
            >
              <b-row align-v="center">
                <b-col
                  class="text-md-left text-center text-muted my-1"
                  clos="12"
                  md=""
                  v-html="cancelChangedMessage"
                />
                <b-col clos="12" md="auto" class="text-center my-1">
                  <b-button
                    size="md"
                    variant="danger"
                    @click="confirmModal = true"
                  >
                    <i class="fas fa-times" />
                    <span class="ml-2" v-text="'انصراف از انتقال'" />
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              v-if="
                !accept && items.length < selectCount && !registered && !loading
              "
              cols="12"
              md="12"
              class="border rounded p-2"
            >
              <b-row align-v="center">
                <b-col
                  class="text-md-left text-center text-muted my-1"
                  clos="12"
                  md=""
                  v-html="addButtonMessage"
                />
                <b-col clos="12" md="auto" class="text-center my-1">
                  <b-button size="md" variant="success" @click="addItem">
                    <i class="fas fa-plus" />
                    <span class="ml-2" v-text="'افزودن مورد جدید'" />
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-overlay>
      </template>
    </TwoStepWrapper>
    <confirm
      title="انصراف از انتقال"
      :description="confirmCancelChangedDescription"
      v-model="confirmModal"
      :loading="loading"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      dynamicClass=""
      @ok="cancelChanged"
      @cancel="confirmModal = false"
    />
  </div>
</template>
<script>
import TwoStepWrapper from "@/components/base/TwoStepWrapper";
import { checkActiveParvandeh, generateApiUrl } from "@/shared/utils";
import confirm from "@/components/base/confirm";
import { pathOr, includes } from "ramda";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import DraggableList from "@/components/global/DraggableList";

export default {
  name: "SelectAndTransferHozehGazayiProvince",
  components: {
    TwoStepWrapper,
    confirm,
    LoadingSpinner,
    DraggableList,
  },
  props: {
    showCancelAlert: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Number,
    },
    limitCountKey: {
      type: String,
    },
    messageKey: {
      type: String,
    },
    getKey: {
      type: String,
    },
    postKey: {
      type: String,
    },
    headerAlertText: {
      type: String,
    },
    type: {
      type: String,
    },
    titleIcon: {
      type: String,
    },
    titleText: {
      type: String,
    },
    isDraggable: {
      type: Boolean,
      default: false,
    },
    forceShow: {
      type: Boolean,
      default: true,
    },
    forceHasHozehSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasHozehSelect: true,
      selectCount: 0,
      accept: false,
      loading: false,
      registered: false,
      submitted: false,
      isEditable: false,
      hasData: false,
      confirmModal: false,
      items: [{ item: {} }],
      draggableItems: [],
      activeParvandehData: {},
      hozehghazayiOptions: [],
      hozehghazayiLoading: false,
      noParvandehCodeMessage: `این صفحه فقط برای کاربرانی قابل مشاهده است که دارای پرونده هستند با توجه به اینکه شما پرونده فعالی ندارید امکان مشاهده این صفحه را ندارید.`,
      noHozehSelectMessage: `این صفحه فقط برای کاربرانی قابل مشاهده است که حوزه استانی خود را انتخاب کرده‌اند با توجه به اینکه شما هنوز حوزه استانی خود را انتخاب نکرده‌اید امکان مشاهده این صفحه را ندارید.`,
      finalHozehGhazayiProvince: {},
      loadingSpinnerText: this.$lang.receiving_data,
    };
  },
  computed: {
    parvandehCode() {
      return pathOr(null, ["code"], this.activeParvandehData);
    },
    validSendCode() {
      /* guidance: get items and check empty it */
      const items = this.isDraggable
        ? this.validateDraggableItems()
        : this.validateItems();
      return !!items.length;
    },
    addButtonMessage() {
      return `جهت افزودن استان حوزه قضایی به لیست اولویت خود بر روی دکمه <b class="text-success">"+ افزودن مورد جدید"</b> کلیک نمایید`;
    },
    cancelChangedMessage() {
      return `جهت انصراف از درخواست ثبت شده برای انتقال حوزه قضایی بر روی دکمه <b class="text-danger">"<i class="fas fa-times"></i> انصراف از انتقال"</b> کلیک نمایید`;
    },
    confirmCancelChangedDescription() {
      return `دقت کنید که با این کار درخواست انتقال حوزه قضایی شما به طور کامل حذف می‌شود.
      <br>
      <br>
      <strong>${this.$lang.are_you_sure}</strong>
      `;
    },
    tableTitleHoze() {
      return this.type === "province"
        ? this.$lang.hoze_ghazaei_name_province
        : this.$lang.hoze_ghazaei_name_detail;
    },
    tableSearchPlaceHolderHoze() {
      return this.type === "province"
        ? this.$lang.hoze_ghazaei_name_province_search
        : this.$lang.hoze_ghazaei_name_detail_search;
    },
    currentProvinceId() {
      /* guidance: check has final province and current page is not select hozeh ostani page or change hozeh ostani page */
      return !includes(this.$route.name, [
        "person_hozeh_ghazayi",
        "change_hozeh_ghazayi",
      ])
        ? pathOr(false, ["id"], this.finalHozehGhazayiProvince)
        : true;
    },
    confirmContentText() {
      return `دقت کنید که این انتخاب پس از نهایی سازی به هیچ وجه قابل تغییر نمی‌باشد.<br><br>`;
    },
    generateDraggableItems() {
      return this.draggableItems.length
        ? this.draggableItems
        : this.hozehghazayiOptions;
    },
    checkingHasHozehSelect() {
      return this.forceHasHozehSelect || this.hasHozehSelect;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    checkActiveParvandeh,
    addItem() {
      const lastItem = this.items[this.items.length - 1];
      const lastItemId = pathOr(null, ["item", "id"], lastItem);
      if (!lastItemId) {
        return this.$notify.warning(
          "برای افزودن مورد جدید موارد قبلی باید تکمیل شده باشند"
        );
      }
      if (this.items.length === this.selectCount) {
        return this.$notify.warning(
          `در حال حاضر فقط امکان انتخاب ${selectCount} مورد می‌باشد`
        );
      }

      this.items.push({ item: {} });
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    validateItems() {
      /* guidance: generate items */
      const items = this.items.map((item) => {
        const id = pathOr(null, ["item", "id"], item);
        if (id) {
          const obj = { status: this.status };
          obj[this.postKey] = id;
          return obj;
        }
        return null;
      });
      /* guidance: remove falsy items */
      return items.filter((item) => item);
    },
    validateDraggableItems() {
      /* guidance: generate items of dragable list */
      const items = this.draggableItems.map((item) => {
        const id = pathOr(null, ["id"], item);
        if (id) {
          const obj = { status: this.status };
          obj[this.postKey] = id;
          return obj;
        }
        return null;
      });
      /* guidance: remove falsy items */
      return items.filter((item) => item);
    },
    resetData() {
      this.items = [{ item: {} }];
      this.isEditable = false;
      this.hasData = false;
      this.registered = false;
      this.$emit("updateIsEditable", false);
      this.$emit("updateRegistered", false);
    },
    generateItems(items, key) {
      const itemsFiltered = items.map((row) => {
        const rowItem = pathOr({}, [key], row);
        return {
          item: {
            id: rowItem.id,
            caption: rowItem.caption,
          },
        };
      });
      this.items = [...itemsFiltered];
      this.validateItems();

      /* guidance: run when is draggble data */
      if (this.isDraggable) {
        const itemsFiltered = items.map((row) => {
          const rowItem = pathOr({}, [key], row);
          return {
            id: rowItem.id,
            caption: rowItem.caption,
          };
        });
        this.draggableItems = [...itemsFiltered];
        this.validateDraggableItems();
      }
    },
    updateAccept(value) {
      this.accept = value;
    },
    updateDraggableItems(value) {
      this.draggableItems = value;
    },
    async getHozehghazayiOptions() {
      try {
        this.hozehghazayiLoading = true;
        let url = generateApiUrl(["profile", "hozeh_ghazayi_province_combo"]);

        if (this.type === "detail") {
          const id = pathOr(null, ["id"], this.finalHozehGhazayiProvince);
          url = generateApiUrl(["profile", "hozeh_ghazayi_detail_combo"], [], {
            hozeh_ghazayi_province_id: id,
          });
        }

        const response = await this.$httpService.get(url);
        this.hozehghazayiOptions = [...pathOr([], ["data", "data"], response)];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.hozehghazayiLoading = false;
      }
    },
    async getHozehghazayi() {
      try {
        this.loading = true;
        this.loadingSpinnerText = this.$lang.receiving_data;
        this.hozehghazayiOptions = [];
        const url = `${this.$config.api_url}${this.$config.profile.hozeh_ghazayi}?status=${this.status}`;
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        const items = pathOr([], ["items"], data);
        this.isEditable = pathOr(false, ["is_editable"], data);
        /* guidance: check selected has hoze ghazayi just when route is trandfer */
        if (this.$route.name === "change_hozeh_ghazayi") {
          this.hasHozehSelect = pathOr(false, ["has_hozeh_select"], data);
        }
        this.selectCount = +pathOr(0, [this.limitCountKey], data);
        this.registered = !!(items.length && !this.isEditable);
        this.$emit("updateIsEditable", this.isEditable);
        this.$emit("updateRegistered", this.registered);
        this.hasData = !!items.length;
        this.finalHozehGhazayiProvince = pathOr(
          {},
          ["final_hozeh_ghazayi_province"],
          data
        );
        this.$emit("updateCurrentProvince", this.finalHozehGhazayiProvince);
        this.$emit("updateAlertMessage", pathOr("", [this.messageKey], data));

        /* guidance: get options fild just when not registred or is edit */
        if (
          (!items.length || this.isEditable) &&
          this.currentProvinceId &&
          this.checkingHasHozehSelect
        ) {
          this.getHozehghazayiOptions();
        }

        /* guidance: generate registred items just when already registered */
        items.length && this.generateItems(items, this.getKey);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.submitted = false;
        this.loading = false;
      }
    },
    async setHozehghazayi(params) {
      try {
        this.loading = true;
        this.loadingSpinnerText = this.$lang.sending_data;
        /* guidance: get items */
        const items = this.isDraggable
          ? this.validateDraggableItems()
          : this.validateItems();

        /* guidance: check empty items */
        if (!items.length) {
          return this.$notify.warning("لطفا حداقل یک مورد را انتخاب کنید");
        }
        const { two_step_code, control_code } = params;
        const payload = {
          control_code,
          two_step_code,
          data: [...items],
        };
        const url = `${this.$config.api_url}${this.$config.profile.hozeh_ghazayi}`;
        const response = this.isEditable
          ? await this.$httpService.put(url, payload)
          : await this.$httpService.post(url, payload);

        this.submitted = true;
        await this.getHozehghazayi();
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
        const finished = pathOr(
          null,
          ["data", "data", "finished"],
          error.response
        );
        finished && this.getHozehghazayi();
      } finally {
        this.loading = false;
      }
    },
    async cancelChanged() {
      try {
        this.loading = true;
        const url = `${this.$config.api_url}${this.$config.profile.hozeh_ghazayi}`;
        const response = await this.$httpService.delete(url);
        this.resetData();
        this.$notify.success(response.data.message);
        await this.getHozehghazayi();
        this.confirmModal = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchData() {
      this.activeParvandehData = { ...checkActiveParvandeh() };
      this.getHozehghazayi();
    },
  },
};
</script>
